import { createRoute } from '@tanstack/react-router'
import { mainLayoutRoute } from 'src/layouts/routes'
import { z } from 'zod'

import { ContactList } from '../pages'

export const contactRoute = createRoute({
  getParentRoute: () => mainLayoutRoute,
  component: () => <ContactList />,
  path: '/contact',
  validateSearch: (search) =>
    z
      .object({
        search: z.string().optional()
      })
      .parse(search)
})
